import { playerViewActionCreator } from '../events/view/player-view';

const { toggleUtilityPanel: toggle } = playerViewActionCreator;

const toggleUtilityPanel = () => dispatch => dispatch(toggle());

export default toggleUtilityPanel;
